export default __webpack_public_path__ + "static/media/Travel.1412231c.gif";